import Vue from 'vue'
import App from './App'
import router from './router'
import ODS from '@onesait/ods'

import axios from 'axios'
import store from './store/store.js'
// import VueCesium from 'vue-cesium'

import '@onesait/ods/lib/theme-onesait/index.css'

// import {
//   Button,
//   Header,
//   Main,
//   Aside,
//   Footer,
//   Row,
//   Col,
//   Container,
//   Dialog,
//   Input,
//   InputNumber,
//   Select,
//   Option,
//   OptionGroup,
//   Form,
//   FormItem,
//   Tabs,
//   TabPane,
//   Loading,
//   Notification,
//   Menu,
//   Submenu,
//   MenuItem,
//   MenuItemGroup,
//   Table,
//   TableColumn,
//   Checkbox,
//   Tooltip,
//   Tag,
//   Icon,
//   Avatar,
//   Breadcrumb,
//   BreadcrumbItem,
//   Autocomplete,
//   Badge,
//   Scrollbar,
//   Kpi,
//   DatePicker,
//   Chart,
//   Cascader,
//   CheckboxGroup,
//   Slider,
//   Alert,
//   Logo
// } from '@onesait/onesait-ds'

// import i18n from './i18n.js'
import i18n from './lang/i18n.js' // eslint-disable-line
// import 'reset-css/reset.css'
import '@/assets/scss/main.scss'
import { truncate, formatDate, formatNumber } from './utils/filters'
// import '@onesait/onesait-ds/lib/theme-onesait/index.css'

axios.defaults.baseURL = process.env.SERVICES_PROVIDER

require('babel-polyfill')

// Vue.use(Button)
// Vue.use(Header)
// Vue.use(Main)
// Vue.use(Aside)
// Vue.use(Footer)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Container)
// Vue.use(Dialog)
// Vue.use(Input)
// Vue.use(InputNumber)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(OptionGroup)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Tabs)
// Vue.use(TabPane)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Checkbox)
// Vue.use(Tooltip)
// Vue.use(Tag)
// Vue.use(Icon)
// Vue.use(Avatar)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
// Vue.use(Badge)
// Vue.use(Scrollbar)
// Vue.use(Kpi)
// Vue.use(DatePicker)
// Vue.use(Chart)
// Vue.use(Loading.directive)
// Vue.use(Autocomplete)
// Vue.use(Cascader)
// Vue.use(CheckboxGroup)
// Vue.use(Slider)
// Vue.use(Alert)
// Vue.use(Logo)
// Vue.use(VueCesium, {
//   cesiumPath: 'https://cesiumjs.org/Cesium/Build/Cesium/'
// })
Vue.use(ODS)
// Vue.prototype.$loading = ODS.Loading.service
// Vue.prototype.$notify = Notification

Vue.config.productionTip = false
Vue.filter('truncate', truncate)
Vue.filter('formatDate', formatDate)
Vue.filter('formatNumber', formatNumber)

// directive close outside
Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.event = function (event) {
      if (!((el === event.target) || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.event)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.event)
  }
})

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

if (process.env.NODE_ENV === 'development') {
  window.BUILDING_3D = 'https://development-smartcities.cwbyminsait.com/data/3DTiles/Edificios/35/tileset.json'
  window.envi = 'des'
} else if (process.env.NODE_ENV === 'preproduccion') {
  window.BUILDING_3D = 'https://development-smartcities.cwbyminsait.com/data/3DTiles/Edificios/35/tileset.json'
  window.envi = 'pre'
} else if (process.env.NODE_ENV === 'production') {
  window.BUILDING_3D = 'https://development-smartcities.cwbyminsait.com/data/3DTiles/Edificios/35/tileset.json'
  window.envi = 'pro'
}



// WEBPACK FOOTER //
// ./src/main.js